import { useEffect, useState } from "react";
import { Navigate, NavigateProps, Params, useLocation, useParams } from "react-router-dom";
import {
  LoadingIndicator,
  useUserPermission,
  UserPermissionGroup,
  useAuthentication,
} from "@shape/reef-shared";
import { Routes, RoutesProps } from "routes";

type PrivateRouteProps = Partial<NavigateProps> & {
  validation: (
    userPermission: UserPermissionGroup[] | undefined,
    params: RoutesProps | Readonly<Params<string>> | undefined
  ) => boolean;
  element: JSX.Element;
  path?: string;
};

export const PrivateRoute = ({ validation, element, ...props }: PrivateRouteProps) => {
  const { userPermissions, isLoading: isLoadingPermissions } = useUserPermission();
  const { error: authError, isAuthenticated, isLoading } = useAuthentication();
  const location = useLocation();
  const params = useParams();
  const [previousLocation, setPreviousLocation] = useState<string | undefined>(undefined);

  useEffect(() => {
    setPreviousLocation(location.pathname || Routes.HomePage);
  }, [location]);

  if (isLoading) return <LoadingIndicator />;

  if (!isAuthenticated || authError)
    return <Navigate to={Routes.LoginPage} state={{ from: previousLocation }} />;

  if (isLoadingPermissions) return <LoadingIndicator />;

  const isValid = validation(userPermissions.data?.user_groups, params);

  return isValid ? (
    element
  ) : (
    <Navigate
      to={{
        pathname: Routes.NotFound,
      }}
      state={{ from: location }}
      {...props}
    />
  );
};
